module.exports = __webpack_public_path__ + "files/b36c0f8b9150a960b72ed86dff539bf8.png";